const CONSENT_SECTIONS = [
  { key: 'procedure', titleKey: 'consentProcedureTitle', descKey: 'consentProcedureDesc' },
  { key: 'risks', titleKey: 'consentRisksTitle', descKey: 'consentRisksDesc' },
  { key: 'alternatives', titleKey: 'consentAlternativesTitle', descKey: 'consentAlternativesDesc' },
  { key: 'outcomes', titleKey: 'consentOutcomesTitle', descKey: 'consentOutcomesDesc' },
  { key: 'aftercare', titleKey: 'consentAftercareTitle', descKey: 'consentAftercareDesc' }
]

const ConsentCheckSection = {
  flow: 'y',
  gap: 'Y',
  padding: 'Z A',
  round: 'Z',
  background: 'inkMid',
  border: '1px solid inkBorder',

  SectionHeading: {
    tag: 'h4',
    text: (el, s) => `{{ ${s.titleKey} | polyglot }}`,
    fontSize: 'Z',
    fontWeight: '700',
    color: 'inkText'
  },

  SectionDescription: {
    tag: 'p',
    text: (el, s) => `{{ ${s.descKey} | polyglot }}`,
    fontSize: 'Y',
    color: 'inkMuted',
    lineHeight: '1.6'
  },

  CheckRow: {
    flow: 'x',
    align: 'center flex-start',
    gap: 'Y',
    cursor: 'pointer',
    onClick: (e, el, s) => {
      const checks = { ...(s.root.consentChecks || {}) }
      checks[s.key] = !checks[s.key]
      s.root.update({ consentChecks: checks })
    },
    Checkbox: {
      tag: 'span',
      text: (el, s) => (s.root.consentChecks || {})[s.key] ? '\u2713' : '',
      width: 'B',
      height: 'B',
      minWidth: 'B',
      round: 'Y',
      border: (el, s) => (s.root.consentChecks || {})[s.key] ? '2px solid teal' : '2px solid inkBorder',
      background: (el, s) => (s.root.consentChecks || {})[s.key] ? 'teal' : 'transparent',
      color: 'white',
      fontSize: 'Y',
      fontWeight: '700',
      flow: 'x',
      align: 'center center',
      flexShrink: '0',
      transition: 'background .15s, border-color .15s'
    },
    CheckLabel: {
      text: '{{ consentAcknowledge | polyglot }}',
      fontSize: 'Y',
      color: 'inkText',
      userSelect: 'none'
    }
  }
}

export const InformedConsentForm = {
  flow: 'y',
  gap: 'Z',

  FormTitle: {
    tag: 'h3',
    text: '{{ informedConsentTitle | polyglot }}',
    fontSize: 'A',
    fontWeight: '700',
    color: 'inkText'
  },

  TreatmentLabel: {
    text: (el, s) => s.treatmentName || '',
    fontSize: 'Z',
    fontWeight: '600',
    color: 'teal'
  },

  Sections: {
    flow: 'y',
    gap: 'Z',
    childExtends: ConsentCheckSection,
    childrenAs: 'state',
    children: () => CONSENT_SECTIONS
  }
}
